/* eslint-disable no-shadow */
import React from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { useParams } from 'react-router-dom';
import { withGrowl } from '../../components/GrowlNotifications';
import { Loading } from '../../components/Loading';
import { growlShape } from '../../components/prop-types';
import { growlErrors } from '../../utils/NotificationUtil';

import { withAccount } from '../../components/AccountContext';
import TransferDetail from './TransferDetail';

import { VIEWER_LOCALE } from '../../components/Query';

export const TRANSFER_QUERY = gql`
  query transferQuery($accountId: ID!, $transferId: ID!) {
    account(id: $accountId) {
      id
      companyInformation {
        displayName
      }
      transfer(id: $transferId) {
        id
        amount
        transferReason
        transactionTime
        fromAccount {
          id
          displayName
        }
        toAccount {
          id
          displayName
        }
        transferredBy {
          id
          firstName
          lastName
        }
      }
    }
  }
`;

const TransferDetailQuery = ({ currentAccount, growl }) => {
  const { transferId } = useParams();

  const variables = {
    accountId: currentAccount,
    transferId,
  };

  return (
    <Query query={VIEWER_LOCALE}>
      {({ data, loading, error }) => {
        if (loading) {
          return <Loading />;
        }
        if (error) {
          growlErrors(growl, error);
        }

        const locale = data && data.viewer ? data.viewer.locale : 'en';

        return (
          <Query query={TRANSFER_QUERY} variables={variables}>
            {({ data, loading, error }) => {
              if (loading) {
                return <Loading />;
              }
              if (error) {
                growlErrors(growl, error);
              }

              return <TransferDetail data={data} currentAccount={currentAccount} locale={locale} />;
            }}
          </Query>
        );
      }}
    </Query>
  );
};

TransferDetailQuery.propTypes = {
  currentAccount: PropTypes.string.isRequired,
  growl: growlShape.isRequired,
};

export default withGrowl(withAccount(TransferDetailQuery));
